"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformTimeToHHMMZonedString = transformTimeToHHMMZonedString;
function transformTimeToHHMMZonedString(date) {
    let hours = date.getHours().toString();
    if (hours.length === 1) {
        hours = `0${hours}`;
    }
    let minutes = date.getMinutes().toString();
    if (minutes.length === 1) {
        minutes = `0${minutes}`;
    }
    return `${hours}:${minutes}`;
}
//# sourceMappingURL=transformTimeToHHMMZonedString.js.map